import ToggleButton from '@mui/material/ToggleButton';
import { styled } from '@mui/material/styles';

export const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
    background: '#e0e0e0',
    borderRadius: 0,
    fontSize: '11px',
    marginRight: theme.spacing(0.5),
    border: 'none',
    marginBottom: theme.spacing(1),
}));
